/**
 * Notification type enum for UI differentiation.
 * Backend currently only returns DEFAULT, but frontend supports
 * BASE_ACTION for notifications with action buttons.
 */
export enum NotificationType {
  DEFAULT = 'DEFAULT',
  BASE_ACTION = 'BASE_ACTION',

  ASSIGNMENT_CREATED = 'ASSIGNMENT_CREATED',
  ASSIGNMENT_DELETED = 'ASSIGNMENT_DELETED',
  ASSIGNMENT_USER_CHANGED = 'ASSIGNMENT_USER_CHANGED',
  ASSIGNMENT_DETAILS_UPDATED = 'ASSIGNMENT_DETAILS_UPDATED',
  ASSIGNMENT_PROJECT_CHANGED = 'ASSIGNMENT_PROJECT_CHANGED',
  ASSIGNMENT_ZERO_RATE = 'ASSIGNMENT_ZERO_RATE',

  PROJECT_MANAGER_ASSIGNED = 'PROJECT_MANAGER_ASSIGNED',
  PROJECT_MANAGER_UNASSIGNED = 'PROJECT_MANAGER_UNASSIGNED',
  PROJECT_ARCHIVED = 'PROJECT_ARCHIVED',
  PROJECT_DELETED = 'PROJECT_DELETED',
  PROJECT_BILLING_UPDATED = 'PROJECT_BILLING_UPDATED',

  TEAM_MEMBER_MANAGER_ASSIGNED = 'TEAM_MEMBER_MANAGER_ASSIGNED',
  TEAM_MEMBER_MANAGER_UNASSIGNED = 'TEAM_MEMBER_MANAGER_UNASSIGNED',
  TEAM_MEMBER_ARCHIVED = 'TEAM_MEMBER_ARCHIVED',
  TEAM_MEMBER_UNARCHIVED = 'TEAM_MEMBER_UNARCHIVED',
  TEAM_MEMBER_DELETED = 'TEAM_MEMBER_DELETED',
  TEAM_MEMBER_BILLING_UPDATED = 'TEAM_MEMBER_BILLING_UPDATED',
  TEAM_MEMBER_CAPACITY_UPDATED = 'TEAM_MEMBER_CAPACITY_UPDATED',

  CLIENT_MANAGER_ASSIGNED = 'CLIENT_MANAGER_ASSIGNED',
  CLIENT_MANAGER_UNASSIGNED = 'CLIENT_MANAGER_UNASSIGNED',
  CLIENT_ARCHIVED = 'CLIENT_ARCHIVED',
  CLIENT_DELETED = 'CLIENT_DELETED',

  ORG_RATE_MANAGEMENT_UPDATED = 'ORG_RATE_MANAGEMENT_UPDATED',
  ORG_DEPARTMENTS_UPDATED = 'ORG_DEPARTMENTS_UPDATED',
  ORG_SENIORITIES_UPDATED = 'ORG_SENIORITIES_UPDATED',
  ORG_ROLES_UPDATED = 'ORG_ROLES_UPDATED',

  TIME_TRACKING_WEEKLY_REMINDER = 'TIME_TRACKING_WEEKLY_REMINDER',
  TIME_TRACKING_MONTHLY_REMINDER = 'TIME_TRACKING_MONTHLY_REMINDER',

  UPCOMING_TEAM_MEMBER_VACATION = 'UPCOMING_TEAM_MEMBER_VACATION',

  TIME_TRACKED_WITHOUT_ASSIGNMENT = 'TIME_TRACKED_WITHOUT_ASSIGNMENT',

  TIME_OFF_REQUEST_CREATED = 'TIME_OFF_REQUEST_CREATED',
  TIME_OFF_REQUEST_CANCELLED = 'TIME_OFF_REQUEST_CANCELLED',
  TIME_OFF_REQUEST_APPROVED = 'TIME_OFF_REQUEST_APPROVED',
  TIME_OFF_REQUEST_DECLINED = 'TIME_OFF_REQUEST_DECLINED',
  TIME_OFF_REQUEST_QUEUED = 'TIME_OFF_REQUEST_QUEUED',
  TIME_OFF_REQUEST_READY_FOR_REVIEW = 'TIME_OFF_REQUEST_READY_FOR_REVIEW',
  TIME_OFF_REQUEST_PARTIALLY_APPROVED = 'TIME_OFF_REQUEST_PARTIALLY_APPROVED',

  WORKLOG_APPROVED_SYNC_CONFLICT = 'WORKLOG_APPROVED_SYNC_CONFLICT',
}
